import { Pipe, PipeTransform } from "@angular/core";
import { NotificationFor } from "../enum/notificationFor";

@Pipe({
    name: "notificationFor",
})
export class NotificationForPipe implements PipeTransform {
    transform(notificationFor: NotificationFor): string {
        switch (notificationFor) {
            case NotificationFor.SuperAdmin:
                return "Super Admin";
            default:
                return "";
        }
    }
}
